import React from "react";
import { ProgramDetailsViewMode } from "../components/program/ProgramDetailsViewButton";

export const ProgramViewContext =
  React.createContext<ProgramDetailsViewMode>(null);

export function useProgramView() {
  return React.useContext(ProgramViewContext);
}
